import styled from '@emotion/styled';
import { InputLabel } from '@material-ui/core';

export const VisuallyHiddenInputLabel = styled(InputLabel)`
    clip: rect(0 0 0 0);
    clipPath: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    whiteSpace: nowrap;
    width: 1px;

    &:focus {
        clip: initial;
        clipPath: initial;
        height: initial;
        overflow: initial;
        position: initial;
        whiteSpace: initial;
        width: initial;
    }
`;
